// Per-company settings (bw-clientsettings) written by the app: company
// currency, transaction categorization switch (CAS-1799), analytics account
// selection and health-indicator thresholds (ReqUpdateCashFlowSettings).
// Kept in sessionStorage so "Reset demo state" restores the defaults.

const STORAGE_KEY = "fidoo-demo-company-settings-v1";

export type DemoCompanySettings = {
  currency?: string;
  categorizationEnabled?: boolean;
  /** Analytics account selection; undefined = all active accounts. */
  selectedAccountIds?: string[];
  healthThresholds?: { thresholdBad: number; thresholdGood: number };
};

function readAll(): Record<string, DemoCompanySettings> {
  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) ?? "{}") as Record<
      string,
      DemoCompanySettings
    >;
  } catch {
    return {};
  }
}

export function getCompanySettings(companyId: string): DemoCompanySettings {
  return readAll()[companyId] ?? {};
}

export function updateCompanySettings(
  companyId: string,
  patch: DemoCompanySettings,
): DemoCompanySettings {
  const all = readAll();
  all[companyId] = { ...all[companyId], ...patch };
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    // Private mode — the change just won't survive a reload.
  }
  return all[companyId];
}

/** LiveClientSettings document ids are `demo-clientsettings-<companyId>`. */
export function companyFromSettingsDocId(documentId: string | undefined): string | undefined {
  return documentId?.startsWith("demo-clientsettings-")
    ? documentId.slice("demo-clientsettings-".length)
    : undefined;
}
